/**
 * @module FeatureRouteGuard
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 *
 * @ngdoc service
 * @name FeatureRouteGuard.ReceiptRetrievalFeatureRouteGuard
 *
 * @description
 * Checks Feature Flag for receipt retrieval to enable or disable the route for /view-document
 *
 */
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { FeatureToggleService } from '@core/feature-toggle/services/feature-toggle.service';
import { FeatureToggleUtilService } from '@support/shared/services/feature-toggle-util.service';
import { SHARED_CONSTANTS } from '@root/shared/constants/shared-constants.constants';

@Injectable()
export class ReceiptRetrievalFeatureRouteGuard {
  constructor(
    private featureToggleService: FeatureToggleService,
    private featureToggleUtilService: FeatureToggleUtilService,
    private router: Router
  ) {}
  public canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const featureRoute = {
      [SHARED_CONSTANTS.VIEW_DOCUMENT]: '!RECEIPTRETRIEVAL',
    };
    try {
      return this.getGuardResponse(state.url, featureRoute[state.url]);
    } catch (e) {
      return true;
    }
  }

  private getGuardResponse(url: string, featureRoute: string): boolean {
    switch (url) {
      case SHARED_CONSTANTS.VIEW_DOCUMENT:
        if (!this.featureToggleUtilService.isReceiptRetrievalEnabled()) {
          this.router.navigate([SHARED_CONSTANTS.HOME]);
        }
        return this.featureToggleUtilService.isReceiptRetrievalEnabled();
      default:
        if (featureRoute) {
          if (featureRoute[0] === '!') {
            const feature = featureRoute.slice(1);
            return !this.featureToggleService.isEnabled(feature);
          }
          return this.featureToggleService.isEnabled(featureRoute);
        }
        return true;
    }
  }
}
